var _dec, _dec2, _dec3, _class, _descriptor, _descriptor2, _descriptor3, _dec4, _dec5, _dec6, _class2, _descriptor4, _descriptor5, _descriptor6, _dec7, _dec8, _class3, _descriptor7, _descriptor8, _dec9, _dec0, _class4, _descriptor9, _descriptor0;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { configure } from "mobx";
import CreateModel from "../../lib/Models/Definition/CreateModel";
import createStratumInstance from "../../lib/Models/Definition/createStratumInstance";
import Terria from "../../lib/Models/Terria";
import objectArrayTrait, { MergeStrategy } from "../../lib/Traits/Decorators/objectArrayTrait";
import primitiveTrait from "../../lib/Traits/Decorators/primitiveTrait";
import ModelTraits from "../../lib/Traits/ModelTraits";
import updateModelFromJson from "../../lib/Models/Definition/updateModelFromJson";
import CommonStrata from "../../lib/Models/Definition/CommonStrata";
configure({
  enforceActions: "always",
  computedRequiresReaction: true
});
let InnerTraits = (_dec = primitiveTrait({
  type: "string",
  name: "Foo",
  description: "Foo"
}), _dec2 = primitiveTrait({
  type: "number",
  name: "Bar",
  description: "Bar"
}), _dec3 = primitiveTrait({
  type: "boolean",
  name: "Baz",
  description: "Baz"
}), _class = class InnerTraits extends ModelTraits {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "foo", _descriptor, this);
    _initializerDefineProperty(this, "bar", _descriptor2, this);
    _initializerDefineProperty(this, "baz", _descriptor3, this);
  }
  static isRemoval(traits) {
    return traits.bar === 42;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "foo", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "bar", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "baz", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
let OuterTraits = (_dec4 = objectArrayTrait({
  type: InnerTraits,
  name: "Inner",
  description: "Inner",
  idProperty: "foo"
}), _dec5 = objectArrayTrait({
  type: InnerTraits,
  name: "Inner by index",
  description: "Inner by index",
  idProperty: "index"
}), _dec6 = primitiveTrait({
  type: "string",
  name: "Other",
  description: "Other"
}), _class2 = class OuterTraits extends ModelTraits {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "inner", _descriptor4, this);
    _initializerDefineProperty(this, "innerByIndex", _descriptor5, this);
    _initializerDefineProperty(this, "other", _descriptor6, this);
  }
}, _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "inner", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "innerByIndex", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, "other", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class2);
let OuterTraitsNoMerge = (_dec7 = objectArrayTrait({
  type: InnerTraits,
  name: "Inner",
  description: "Inner",
  idProperty: "foo",
  merge: MergeStrategy.None
}), _dec8 = primitiveTrait({
  type: "string",
  name: "Other",
  description: "Other"
}), _class3 = class OuterTraitsNoMerge extends ModelTraits {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "inner", _descriptor7, this);
    _initializerDefineProperty(this, "other", _descriptor8, this);
  }
}, _descriptor7 = _applyDecoratedDescriptor(_class3.prototype, "inner", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class3.prototype, "other", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class3);
let OuterTraitsMergeTop = (_dec9 = objectArrayTrait({
  type: InnerTraits,
  name: "Inner",
  description: "Inner",
  idProperty: "foo",
  merge: MergeStrategy.TopStratum
}), _dec0 = primitiveTrait({
  type: "string",
  name: "Other",
  description: "Other"
}), _class4 = class OuterTraitsMergeTop extends ModelTraits {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "inner", _descriptor9, this);
    _initializerDefineProperty(this, "other", _descriptor0, this);
  }
}, _descriptor9 = _applyDecoratedDescriptor(_class4.prototype, "inner", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor0 = _applyDecoratedDescriptor(_class4.prototype, "other", [_dec0], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class4);
class TestModel extends CreateModel(OuterTraits) {}
class TestModelNoMerge extends CreateModel(OuterTraitsNoMerge) {}
class TestModelMergeTop extends CreateModel(OuterTraitsMergeTop) {}
describe("objectArrayTrait", function () {
  it("returns an empty model if all strata are undefined", function () {
    const terria = new Terria();
    const model = new TestModel("test", terria);
    model.strata.set("definition", createStratumInstance(OuterTraits));
    model.strata.set("user", createStratumInstance(OuterTraits));
    expect(model.inner).toBeDefined();
  });
  it("combines values from different strata", function () {
    const terria = new Terria();
    const model = new TestModel("test", terria);
    const definition = createStratumInstance(OuterTraits);
    const user = createStratumInstance(OuterTraits);
    model.strata.set("definition", definition);
    model.strata.set("user", user);
    definition.inner = [createStratumInstance(InnerTraits), createStratumInstance(InnerTraits)];
    definition.inner[0].foo = "a";
    definition.inner[0].bar = 1;
    definition.inner[1].foo = "b";
    definition.inner[1].bar = 2;
    definition.inner[1].baz = true;
    user.inner = [createStratumInstance(InnerTraits), createStratumInstance(InnerTraits)];
    user.inner[0].foo = "b";
    user.inner[0].baz = false;
    user.inner[1].foo = "c";
    user.inner[1].bar = 3;
    expect(model.inner).toBeDefined();
    if (model.inner !== undefined) {
      expect(model.inner.length).toEqual(3);
      const a = model.inner.filter(x => x.foo === "a")[0];
      const b = model.inner.filter(x => x.foo === "b")[0];
      const c = model.inner.filter(x => x.foo === "c")[0];
      expect(a).toBeDefined();
      expect(b).toBeDefined();
      expect(c).toBeDefined();
      expect(a.bar).toEqual(1);
      expect(a.baz).toBeUndefined();
      expect(b.bar).toEqual(2);
      expect(b.baz).toEqual(false);
      expect(c.bar).toEqual(3);
      expect(c.baz).toBeUndefined();
    }
  });
  it("updates to reflect array elements added after evaluation", function () {
    const terria = new Terria();
    const model = new TestModel("test", terria);
    const definition = createStratumInstance(OuterTraits);
    const user = createStratumInstance(OuterTraits);
    model.strata.set("definition", definition);
    model.strata.set("user", user);
    definition.inner = [createStratumInstance(InnerTraits), createStratumInstance(InnerTraits)];
    definition.inner[0].foo = "a";
    definition.inner[0].bar = 1;
    definition.inner[1].foo = "b";
    definition.inner[1].bar = 2;
    definition.inner[1].baz = true;
    user.inner = [createStratumInstance(InnerTraits), createStratumInstance(InnerTraits)];
    user.inner[0].foo = "b";
    user.inner[0].baz = false;
    user.inner[1].foo = "c";
    user.inner[1].bar = 3;
    expect(model.inner).toBeDefined();
    if (model.inner !== undefined) {
      expect(model.inner.length).toEqual(3);
      const newOne = createStratumInstance(InnerTraits);
      definition.inner.push(newOne);
      newOne.foo = "c";
      newOne.bar = 4;
      newOne.baz = true;
      expect(model.inner.length).toEqual(3);
      const c = model.inner.filter(x => x.foo === "c")[0];
      expect(c.bar).toEqual(3);
      expect(c.baz).toEqual(true);
    }
  });
  it("allows strata to remove elements from top level", function () {
    const terria = new Terria();
    const model = new TestModel("test", terria);
    const definition = createStratumInstance(OuterTraits);
    const user = createStratumInstance(OuterTraits);
    model.strata.set("definition", definition);
    model.strata.set("user", user);
    definition.inner = [createStratumInstance(InnerTraits), createStratumInstance(InnerTraits)];
    definition.inner[0].foo = "a";
    definition.inner[0].bar = 1;
    definition.inner[1].foo = "b";
    definition.inner[1].bar = 2;
    definition.inner[1].baz = true;
    user.inner = [createStratumInstance(InnerTraits), createStratumInstance(InnerTraits), createStratumInstance(InnerTraits)];
    user.inner[0].foo = "b";
    user.inner[0].bar = 42; // indicates removed, according to InnerTraits.isRemoval.
    user.inner[1].foo = "c";
    user.inner[1].bar = 3;
    user.inner[2].foo = "a";
    user.inner[2].bar = 11;

    // Here we expect the order to be "a" and then "c" as "a" is defined in a lower strata to "c"
    expect(model.inner.length).toEqual(2);
    expect(model.inner[0].foo).toEqual("a");
    expect(model.inner[0].bar).toEqual(11);
    expect(model.inner[1].foo).toEqual("c");
  });
  it("allows strata to remove elements from bottom level", function () {
    const terria = new Terria();
    const model = new TestModel("test", terria);
    const definition = createStratumInstance(OuterTraits);
    const user = createStratumInstance(OuterTraits);
    model.strata.set("definition", definition);
    model.strata.set("user", user);
    definition.inner = [createStratumInstance(InnerTraits), createStratumInstance(InnerTraits)];

    // Order is important here:
    // - b (with removal)
    // - a
    definition.inner[0].foo = "b";
    definition.inner[0].bar = 42; // indicates removed, according to InnerTraits.isRemoval.
    definition.inner[0].baz = true;
    definition.inner[1].foo = "a";
    definition.inner[1].bar = 1;
    user.inner = [createStratumInstance(InnerTraits), createStratumInstance(InnerTraits), createStratumInstance(InnerTraits)];

    // Order:
    // - b (removed in "definition")
    // - c
    // - a (exists in "definition")
    user.inner[0].foo = "b";
    user.inner[0].bar = 100;
    user.inner[1].foo = "c";
    user.inner[1].bar = 3;
    user.inner[2].foo = "a";
    user.inner[2].bar = 11;

    // So we expect this order:
    // - a (because it is in "definition")
    // - b (removed in "definition" so treated as from "user")
    // - c (from "user")
    expect(model.inner.length).toEqual(3);
    expect(model.inner[0].foo).toEqual("a");
    expect(model.inner[0].bar).toEqual(11);
    expect(model.inner[1].foo).toEqual("b");
    expect(model.inner[1].bar).toEqual(100);
    expect(model.inner[2].foo).toEqual("c");
    expect(model.inner[2].bar).toEqual(3);
    expect(model.inner[2].baz).toBeUndefined();
  });
  it("updates to reflect new strata added after evaluation", function () {
    const terria = new Terria();
    const model = new TestModel("test", terria);
    const newObj = model.addObject("user", "inner", "test");
    expect(newObj).toBeDefined();
    if (newObj) {
      expect(newObj.foo).toBe("test");
      newObj.setTrait("user", "bar", 4);
      expect(newObj.bar).toBe(4);
      newObj.setTrait("definition", "baz", true);
      expect(newObj.baz).toBe(true);
    }
    expect(model.inner.length).toBe(1);
    expect(model.inner[0].foo).toBe("test");
    expect(model.inner[0].bar).toBe(4);
    expect(model.inner[0].baz).toBe(true);
  });
  it("handles idProperty = index", function () {
    const terria = new Terria();
    const model = new TestModel("test", terria);

    // Create new object and set removal
    const firstObject = model.addObject("definition", "innerByIndex");
    firstObject === null || firstObject === void 0 || firstObject.setTrait("definition", "foo", "definition");
    firstObject === null || firstObject === void 0 || firstObject.setTrait("user", "bar", 10);
    expect(model.innerByIndex.length).toBe(1);
    expect(model.innerByIndex[0].foo).toBe("definition");

    // Remove first object by setting bar = 42
    firstObject === null || firstObject === void 0 || firstObject.setTrait("user", "bar", 42);
    expect(model.innerByIndex.length).toBe(0);

    // Add new object to user
    const secondObject = model.addObject("user", "innerByIndex");
    secondObject === null || secondObject === void 0 || secondObject.setTrait("user", "foo", "user");
    secondObject === null || secondObject === void 0 || secondObject.setTrait("user", "bar", 10);
    expect(model.innerByIndex.length).toBe(1);
    expect(model.innerByIndex[0].foo).toBe("user");

    // Add new object to definition
    const thirdObject = model.addObject("definition", "innerByIndex");
    thirdObject === null || thirdObject === void 0 || thirdObject.setTrait("user", "foo", "definition");
    thirdObject === null || thirdObject === void 0 || thirdObject.setTrait("user", "bar", 10);
    expect(model.innerByIndex.length).toBe(2);
    expect(model.innerByIndex[0].foo).toBe("user");
    expect(model.innerByIndex[1].foo).toBe("definition");

    // Add new object to user
    const fourthObject = model.addObject("user", "innerByIndex");
    fourthObject === null || fourthObject === void 0 || fourthObject.setTrait("user", "foo", "user2");
    fourthObject === null || fourthObject === void 0 || fourthObject.setTrait("user", "bar", 20);
    expect(model.innerByIndex.length).toBe(3);
    expect(model.innerByIndex[0].foo).toBe("user");
    expect(model.innerByIndex[1].foo).toBe("definition");
    expect(model.innerByIndex[2].foo).toBe("user2");
  });
  it("updates to reflect new strata added after evaluation (with no merge)", function () {
    const terria = new Terria();
    const model = new TestModelNoMerge("test", terria);
    const newObj = model.addObject("user", "inner", "test");
    expect(newObj).toBeDefined();
    if (newObj) {
      expect(newObj.foo).toBe("test");
      newObj.setTrait("user", "bar", 4);
      expect(newObj.bar).toBe(4);
      newObj.setTrait("definition", "baz", true);
      expect(newObj.baz).toBeUndefined();
      newObj.setTrait("user", "baz", true);
      expect(newObj.baz).toBeTruthy();
    }
    expect(model.inner.length).toBe(1);
    expect(model.inner[0].foo).toBe("test");
    expect(model.inner[0].bar).toBe(4);
    expect(model.inner[0].baz).toBe(true);
  });
  it("no error when a model has 0 strata and merge = top", function () {
    const terria = new Terria();
    const model = new TestModelMergeTop("test", terria);
    expect(model.inner.length).toBe(0);
  });
  it("updates to reflect new strata added after evaluation (with merge = top)", function () {
    const terria = new Terria();
    const model = new TestModelMergeTop("test", terria);
    updateModelFromJson(model, CommonStrata.definition, {
      inner: [{
        foo: "this-exists-in-definition-and-user",
        bar: 1,
        baz: false
      }, {
        foo: "this-exists-in-definition",
        bar: 2,
        baz: true
      }, {
        foo: "this-also-exists-in-definition-and-user"
      }]
    });
    expect(model.inner.length).toBe(3);
    expect(model.inner[0].foo).toBe("this-exists-in-definition-and-user");
    expect(model.inner[0].bar).toBe(1);
    expect(model.inner[0].baz).toBe(false);
    expect(model.inner[1].foo).toBe("this-exists-in-definition");
    expect(model.inner[1].bar).toBe(2);
    expect(model.inner[1].baz).toBe(true);
    expect(model.inner[2].foo).toBe("this-also-exists-in-definition-and-user");
    updateModelFromJson(model, CommonStrata.user, {
      inner: [{
        foo: "this-exists-in-definition-and-user",
        baz: true
      }, {
        foo: "this-also-exists-in-definition-and-user",
        bar: 3,
        baz: true
      }]
    });
    expect(model.inner.length).toBe(2);
    expect(model.inner[0].foo).toBe("this-exists-in-definition-and-user");
    expect(model.inner[0].bar).toBe(1);
    expect(model.inner[0].baz).toBe(true);
    expect(model.inner[1].foo).toBe("this-also-exists-in-definition-and-user");
    expect(model.inner[1].bar).toBe(3);
    expect(model.inner[1].baz).toBe(true);
  });
});